import React from 'react';
import {ReactComponent as GPS} from '../../assets/gps-line.svg';

type LocationNameProps = {
  locationName: string;
};
function LocationName({locationName}: LocationNameProps) {
  return (
    <div
      className={
        'border-b border-[#e9eced] px-[10px] pt-[13px] pb-[25px] flex items-center'
      }
    >
      <GPS className={'w-[43px] h-[43px] mr-5'} />
      <div className={'flex flex-col justify-between'}>
        <h5 className={'text-xs m-0 text-[#9fa1a4] mb-[2px]'}>
          名稱 <span className="text-[#be0b0b]">*</span> ：
        </h5>
        <p className={'m-0 text-lg'} data-test-id={'location-name'}>
          {locationName}
        </p>
      </div>
    </div>
  );
}

export default LocationName;
